import { Outlet } from "react-router-dom";

const Userlayout = () => {
  return (
    <><Outlet /></>
  );
};

export default Userlayout;